import React, { Component } from 'react';

export default class Header extends Component {
    render() {
        return (
            <header className="header-container">
                <img
                    className="pointer"
                    onClick={this.props.profileIsOpen ? this.props.close : this.props.open}
                    style={{
                        opacity: this.props.profileIsOpen ? 1 : 0.2,
                        width: 30,
                        height: 'auto'
                    }}
                    alt="account-logo"
                    src={require('../images/account.png')}
                />
                <img
                    className="pointer"
                    onClick={this.props.close}
                    style={{
                        width: 25,
                        height: 'auto',
                        opacity: this.props.profileIsOpen ? 0.4 : 1
                    }}
                    alt="tinder-logo"
                    src={require('../images/tinder.png')}
                />
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:jeremydanner2@gmail.com?Subject=Tänk%20på%20att%20jag%20är%20nöjd%20med%20mitt%20jobb%20som%20jag%20har%20idag,%20du%20måste%20locka%20med%20något%20riktigt%20bra%20i%20så%20fall!%20😅"
                >
                    <img
                        className="pointer"
                        style={{ opacity: 0.2, width: 45, height: 'auto' }}
                        alt="chat-log"
                        src={require('../images/chat.png')}
                    />
                </a>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header.js